import styled from 'styled-components';

export const DynamicLayoutContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  width: ${(props) =>
    props.layout === 'modal' ? '800px' : `${props.width}px`};
  max-width: 90vw;
  max-height: 90vh;
  background-color: white;
  box-shadow: ${(props) =>
    props.layout === 'modal'
      ? '0 4px 6px rgba(0,0,0,0.1)'
      : '-2px 0 5px rgba(0, 0, 0, 0.5)'};
  border-radius: ${(props) => (props.layout === 'modal' ? '8px' : '0')};
  z-index: 1050;
  display: flex;
  flex-direction: column;
  animation: ${(props) =>
      props.layout === 'modal' ? 'modalFadeIn' : 'sidebarSlideIn'}
    0.3s ease;

  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.8);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  @keyframes sidebarSlideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  ${(props) =>
    props.layout === 'sidebar' &&
    `
    top: 0;
    right: 0;
    left: auto;
    transform: none;
    height: 100%;
    max-height: none;
    width: ${props.width}px;
    overflow: hidden;
  `}
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  animation: overlayFadeIn 0.3s ease;

  @keyframes overlayFadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const DragHandle = styled.div`
  width: 5px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: ew-resize;
  background-color: #ccc;
  z-index: 2060;
  display: ${(props) => (props.layout === 'sidebar' ? 'block' : 'none')};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
`;

export const ModalBody = styled.div`
  flex-grow: 1;
  padding: 1.5rem;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  max-height: calc(100% - 7rem);
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
`;
